'use client';

import React from 'react';
import { Terms } from '@/features/client/Terms/Terms';
import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';

export const TermsPage = () => {
  return (
    <div>
      <MainSectionLayout variant="primary" layout="circle">
        <MainSection
          label="Terms"
          title="Terms and conditions"
          description=""
        />
      </MainSectionLayout>
      <Section variant="secondary">
        <Container>
          {' '}
          <Terms />
        </Container>
      </Section>
      <Section variant="secondary">
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default TermsPage;
